import { useContext, useRef, useState } from 'react';
import { Icon } from '@iconify/react';
import globeOutline from '@iconify/icons-eva/globe-outline';
import checkmarkFill from '@iconify/icons-eva/checkmark-fill';
// material
import { alpha } from '@mui/material/styles';
import {
  Box,
  MenuItem,
  ListItemText,
  ListItemIcon,
  ButtonBase,
  Typography,
} from '@mui/material';
// components
import MenuPopover from '../../components/MenuPopover';
import { Context } from '../../context';

// ----------------------------------------------------------------------

export const TIMEZONES = [
  {
    value: 'UTC',
    label: 'UTC (UTC)',
  },
  {
    value: 'Europe/London',
    label: 'UK (GMT/BST)',
  },
  {
    value: 'Asia/Kolkata',
    label: 'India (IST)',
  },
  {
    value: 'Europe/Paris',
    label: 'Europe (CET/CEST)',
  },
];

// ----------------------------------------------------------------------

export default function TimezonePopover() {
  const anchorRef = useRef(null);
  const [open, setOpen] = useState(false);
  const { timezone } = useContext(Context);
  const { timezone: selected, setTimezone } = timezone;

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleSelect = (option) => {
    setTimezone(option);
    handleClose();
  };

  return (
    <>
      <ButtonBase
        ref={anchorRef}
        onClick={handleOpen}
        sx={(theme) => ({
          display: 'flex',
          alignItems: 'center',
          gap: 1,
          height: 44,
          px: 1.5,
          borderRadius: theme.shape.borderRadius,
          color: theme.palette.text.primary,
          backgroundColor: alpha(theme.palette.background.paper, 0.9),
          border:
            theme.palette.mode === 'light'
              ? '1px solid transparent'
              : `1px solid ${alpha(theme.palette.divider, 0.8)}`,
          ...(open && {
            backgroundColor: alpha(theme.palette.primary.main, theme.palette.action.focusOpacity),
          }),
        })}
      >
        <Icon icon={globeOutline} width={20} height={20} />
        <Typography variant="subtitle2" noWrap>
          {selected.label}
        </Typography>
      </ButtonBase>

      <MenuPopover open={open} onClose={handleClose} anchorEl={anchorRef.current} sx={{ width: 220 }}>
        <Box sx={{ py: 1 }}>
          {TIMEZONES.map((option) => (
            <MenuItem
              key={option.value}
              selected={option.value === selected.value}
              onClick={() => handleSelect(option)}
              sx={{ py: 1, px: 2.5 }}
            >
              <ListItemText primaryTypographyProps={{ variant: 'body2' }}>
                {option.label}
              </ListItemText>
              {option.value === selected.value && (
                <ListItemIcon sx={{ minWidth: 'auto' }}>
                  <Icon icon={checkmarkFill} width={18} height={18} />
                </ListItemIcon>
              )}
            </MenuItem>
          ))}
        </Box>
      </MenuPopover>
    </>
  );
}
